import { createRouter, createMemoryHistory, createWebHistory } from 'vue-router';
import { buildAppRoutes } from './factory';

/** 除英文首页 `/` 外，统一补尾斜杠，与 SSR 301 及 canonical 一致 */
function enforceTrailingSlash(router) {
	router.beforeEach((to, _from, next) => {
		if (to.path !== '/' && !to.path.endsWith('/')) {
			return next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			});
		}
		next();
	});
}

export default function createRouterInstance() {
	const router = createRouter({
		history: import.meta.env.SSR ? createMemoryHistory(import.meta.env.BASE_URL) : createWebHistory(import.meta.env.BASE_URL),
		routes: buildAppRoutes(),
		scrollBehavior(_to, _from, savedPosition) {
			if (savedPosition) return savedPosition;
			return { top: 0, left: 0 };
		},
	});
	enforceTrailingSlash(router);
	return router;
}
